import { ApiBase } from './apiBase';
import { METHOD } from '../constant/api';

export class ApiHardwaresSerialDealer extends ApiBase {
  private static baseUrl: string = '/hardwares';

  static async put(serial: string, dealer: string): Promise<any> {
    const url = `${this.baseUrl}/${serial}/dealer`;

    const data = {
      dealer: dealer,
    };
    const config = { headers: { Authorization: this.token } };

    return await this.sendRequest(METHOD.PUT, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }
}
